import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import * as styles from "./CardTag.module.scss";
type Props = {
  backgroundColor?: "white" | "productType" | "expedition";
  uppercase?: boolean;
  variant?: "default" | "small";
};

const CardTag: React.FC<PropsWithChildren<Props>> = ({
  backgroundColor = "white",
  uppercase = true,
  variant = "default",
  children
}) => {
  return (
    <li
      className={clsx(styles.tag, {
        [styles.upperCase]: uppercase,
        [styles.white]: backgroundColor == "white",
        [styles.productType]: backgroundColor == "productType",
        [styles.productTypeExpedition]: backgroundColor == "expedition",
        [styles.smallVariant]: variant == "small"
      })}
    >
      {children}
    </li>
  );
};

export default CardTag;
